import React from 'react';
import { IDENTITY_DIALOG } from '../../../redux/constants/dialogs';
import { nameOrEmail } from '../../../utils/helper';

const styles = {
  link: {
    cursor: 'pointer',
  },
}

const IdentityLabel = ({ identity, showDialog }) => {
  return (<a style={styles.link} onClick={() => showDialog(IDENTITY_DIALOG, { identity })}>{nameOrEmail(identity)}</a>);
};

export default IdentityLabel;


// WEBPACK FOOTER //
// ./src/components/Common/IdentityLabel/index.js